import { render, staticRenderFns } from "./reviewApplication.vue?vue&type=template&id=57858876&scoped=true"
import script from "./reviewApplication.vue?vue&type=script&lang=js"
export * from "./reviewApplication.vue?vue&type=script&lang=js"
import style0 from "./reviewApplication.vue?vue&type=style&index=0&id=57858876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57858876",
  null
  
)

export default component.exports